import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import "../styles/contact.scss";
import Nav from "./Nav";
import Footer from "./Footer";
import PageMeta from "./PageMeta";
import StoreCta from "./StoreCta";
import { FadeInUp, StaggerChildren, StaggerItem } from "./motion";
import {
  contactHero,
  contactChannels,
  socialLinks,
  contactNote,
  contactMeta,
} from "../content/contact";
import {
  organizationSchema,
  buildBreadcrumbSchema,
  innerPageBreadcrumbs,
} from "../content/seo";

const channelIcons = {
  "General enquiries": EmailOutlinedIcon,
  Partnerships: HandshakeOutlinedIcon,
};

const Contact = () => {
  const breadcrumbSchema = buildBreadcrumbSchema(innerPageBreadcrumbs.contact);

  return (
    <main className="contact">
      <PageMeta
        meta={contactMeta}
        jsonLd={[organizationSchema, breadcrumbSchema]}
      />
      <Nav page="" />
      <FadeInUp as="header" className="page-hero">
        <h1>{contactHero.title}</h1>
        <p>{contactHero.subtitle}</p>
      </FadeInUp>
      <section className="content-section">
        <StaggerChildren className="contact-cards">
          {contactChannels.map((channel) => {
            const Icon = channelIcons[channel.title] || EmailOutlinedIcon;
            return (
              <StaggerItem key={channel.title} className="info-card contact-card">
                <div className="contact-card__icon" aria-hidden="true">
                  <Icon fontSize="large" />
                </div>
                <h2>{channel.title}</h2>
                <p>{channel.description}</p>
                <a href={`mailto:${channel.email}`} className="email-link">
                  {channel.email}
                </a>
              </StaggerItem>
            );
          })}
        </StaggerChildren>
        <FadeInUp className="info-card contact-social">
          <h2>Follow us</h2>
          <div className="social-links">
            {socialLinks.map((link) => (
              <a
                key={link.name}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {link.handle ? `${link.name} (${link.handle})` : link.name}
              </a>
            ))}
          </div>
        </FadeInUp>
        <FadeInUp>
          <p className="content-note">{contactNote}</p>
        </FadeInUp>
        <FadeInUp>
          <StoreCta className="content-cta" />
        </FadeInUp>
      </section>
      <Footer />
    </main>
  );
};

export default Contact;
